import { FEATURES } from '../constants/content';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

export default function Features() {
  const ref = useScrollAnimation();

  return (
    <section id="features" ref={ref} className="fade-in mx-auto w-full max-w-6xl px-4 py-16 md:px-8">
      <h2 className="font-[Nunito] text-3xl font-extrabold text-[#5B3FA6] md:text-4xl">Everything a parent actually needs</h2>
      <p className="mt-3 text-lg text-[#6F655E]">Built by parents, for parents. No fluff.</p>
      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {FEATURES.map((feature, index) => (
          <article
            key={feature.title}
            className="feature-card rounded-2xl border-l-4 border-[#D8CAF8] bg-white p-6 shadow-sm transition-all hover:-translate-y-1 hover:shadow-md"
            style={{ transitionDelay: `${index * 100}ms` }}
          >
            <div className="text-3xl">{feature.icon}</div>
            <h3 className="mt-4 font-[Nunito] text-xl font-bold text-[#4A3F66]">{feature.title}</h3>
            <p className="mt-3 text-[#6F655E]">{feature.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

